export default "__VITE_ASSET__DMMyYffM__"